import ScrollView from 'devextreme-react/scroll-view';

export function ItComingSoonPage() {
  return (
    <ScrollView>
      <div style={{ padding: '1rem 1.25rem' }}>
        <h2>Coming soon</h2>
        <p>This Information Technology area is under construction.</p>
      </div>
    </ScrollView>
  );
}
